export const NO_AVAILABILITY_BADGE = "No available slots";

export const getTutorStatusBadge = ({
  badge,
  isStaticTutor,
  availabilityLoaded,
  futureAvailabilityCount,
}) => {
  if (!isStaticTutor && availabilityLoaded && futureAvailabilityCount === 0) {
    return NO_AVAILABILITY_BADGE;
  }

  return badge;
};
